// extracted by mini-css-extract-plugin
export var drawerPaper = "_1i-0";
export var itemImage = "_1i-1";